export const saveColumnWidth = ({ sizeData, columnWidth, setColumnWidth }) => {
  sizeData.forEach((column) => {
    if (columnWidth[column.id] !== column.value) {
      setColumnWidth({ [column.id]: column.value })
    }
  })
}
